export function formatNumber(number: number | string | null | undefined) {
  const value = Number(number);

  if (number === null || number === undefined || Number.isNaN(value)) {
    return '0';
  }

  // Преобразуем число в строку с двумя десятичными знаками
  let numStr = Number.isInteger(value) ? String(value) : value.toFixed(2);

  // Разделяем число на целую и дробную части
  let [integerPart, decimalPart] = Number.isInteger(value)
    ? [numStr, undefined]
    : numStr.split('.');

  // Разбиваем целую часть на тысячи
  let parts = [];
  while (integerPart.length > 3) {
    parts.unshift(integerPart.slice(-3));
    integerPart = integerPart.slice(0, -3);
  }
  if (integerPart) {
    parts.unshift(integerPart);
  }

  // Объединяем части с разделителем и добавляем дробную часть
  return decimalPart ? parts.join(' ') + '.' + decimalPart : parts.join(' ');
}
